import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AudioList from "./pages/AudioList";
import AudioDetail from "./pages/AudioDetail";
import About from "./pages/About";
import NotFound from "./pages/NotFound";

const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', { page_path: path });
  }
};

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);
  return null;
};

// Re-mounts page content on navigation so each page animates in
const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <div key={location.pathname} className="animate-page-in">
      <Routes location={location}>
        <Route path="/" element={<AudioList />} />
        <Route path="/audio/:id" element={<AudioDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <Router basename="/aws-podcast">
      <RouteTracker />
      <div className="min-h-screen flex flex-col bg-paper text-slate-700 font-sans">
        <Header />
        <main className="flex-1">
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
